import MenuSvg from "./MenuSvg"
import { useEffect, useState } from 'react'

import useCamera from "./stores/useCamera"
import useVue from "./stores/useVue"
import Keyboard from "./Keyboard.js"



export default function Interface() {
    {/* ----------------------------- Set Camera mode ---------------------------- */ }
    const setCameraMode = useCamera((state) => state.setCameraMode)
    const setCameraPosition = (mode) => {
        setCameraMode(mode)
    }
    {/* -----------------------------Fin Set Camera mode ---------------------------- */ }



    {/* ----------------------------- Set Vue mode ---------------------------- */ }
    const setVueMode = useVue((state) => state.setVueMode)
    const setVue = (mode) => setVueMode(mode)

    const vueMode = useVue((state) => state.vueMode)
    {/* -----------------------------Fin Set Vue mode ---------------------------- */ }




    {/* -------------------------- Toggle Menu Principal ------------------------- */ }
    const [toggleMenuPrincipal, setToggleMenuPrincipal] = useState(false)
    const handleToggleMenuPrincipal = () => {
        setToggleMenuPrincipal(!toggleMenuPrincipal)
    }
    {/* -------------------------- Fin Toggle Menu Principal ------------------------- */ }





    return <>
        <div className="menu-wrapper">
            <div className="menu">
                <div className={`menu-list ${toggleMenuPrincipal ? 'active' : ''}`}>
                    <ul>
                        {vueMode === 'appartement' && <li onClick={setVue.bind(this, 'house')}>Voir l'immeuble</li>}
                        {vueMode === 'house' && <li onClick={setVue.bind(this, 'appartement')}>Voir l'appartement</li>}
                        <li onClick={setCameraPosition.bind(this, 'top')}>Vue de haut</li>
                        <li onClick={setCameraPosition.bind(this, 'init')}>Retour à la vue principale</li>
                    </ul>
                </div>
                <div className={`menu-button ${toggleMenuPrincipal ? 'active' : ''}`}
                    onClick={handleToggleMenuPrincipal}>
                    <MenuSvg />
                </div>
            </div>
        </div>
        <Keyboard />
    </>

}